export default "__VITE_ASSET__CihHtPlU__"